export const Room = () => {
  return (
    <svg className="dashboard__image" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
      <path d="M0.1,50.4c0,1.3,1.1,2.4,2.4,2.4h54.9c1.3,0,2.4-1.1,2.4-2.4V9.4c0-1.3-1.1-2.4-2.4-2.4H2.6C1.2,6.9,0.1,8,0.1,9.4V50.4z
        M1.9,11.4c0-1.5,1.2-2.7,2.7-2.7L57,8.5c0,0,0,0,0,0c0.3,0,0.6,0.1,0.9,0.4c0.2,0.2,0.4,0.6,0.4,0.9l-0.2,40.1
        c0,0.7-0.6,1.2-1.3,1.2H4.6c-1.5,0-2.7-1.2-2.7-2.7V11.4z"/>
      <path d="M52.5,14.2c0-0.3-0.2-0.5-0.5-0.5H7.9c-0.3,0-0.5,0.2-0.5,0.5v33.2c0,0.3,0.2,0.5,0.5,0.5H52c0.3,0,0.5-0.2,0.5-0.5V33.5
        c0-0.3-0.2-0.5-0.5-0.5h-6.8c-0.2,0-0.5-0.1-0.6-0.3c-0.1-0.2-0.2-0.4-0.1-0.7c0.6-2,2.1-4.5,6.1-5.1c0,0,0.1,0,0.1,0l1.3,0
        c0.3,0,0.5-0.2,0.5-0.5V14.2z M9.2,15.5h27.2v13.6H22.3l0-0.1c-1-7.2-6.9-8.1-8.7-8.2c0,0-0.1,0-0.1,0c-0.5,0-0.9,0.4-0.9,0.9v7.5
        H9.2V15.5z M36.4,46.1H9.2V30.9h5.2v-8.3l0.1,0c1.6,0.3,5.2,1.4,6,6.5l0,1.7h15.9v2.9l-0.1,0c-7.7,1.3-7.8,8.6-7.8,8.7
        c0,0.5,0.4,0.9,0.9,0.9h7V46.1z M50.7,25.1l-0.1,0c-8.2,1.1-8.2,8.7-8.2,8.7c0,0.5,0.4,0.9,0.9,0.9h7.4v11.4H38.1v-4.5h-7.8l0-0.1
        c0.3-1.8,1.5-5,6-5.9l1.7-0.2V15.5h12.6V25.1z"/>
    </svg>
  );
};
